import React from 'react';
import PropTypes from 'prop-types';

import { InputWrapper } from './css';
import Note from '../../note';

const FieldTextNote = ({ data }) => {
  const { note, isWarningMessage, noteType, isShowNoteBackground } = data;
  return (
    <InputWrapper>
      {note && note.content && (
        <Note
          type="richText"
          data={note}
          variant={noteType}
          isWarningMessage={isWarningMessage}
          isShowNoteBackground={isShowNoteBackground}
        />
      )}
    </InputWrapper>
  );
};

FieldTextNote.propTypes = {
  data: PropTypes.shape({
    noteType: PropTypes.string,
    note: PropTypes.shape({
      content: PropTypes.arrayOf(PropTypes.object)
    }).isRequired,
    isWarningMessage: PropTypes.bool.isRequired,
    isShowNoteBackground: PropTypes.bool.isRequired
  }).isRequired
};

export default FieldTextNote;
